import styled from '@emotion/styled';

import Card from 'components/global/Card';

import { Breakpoints } from 'utils/const.styles';

export const ShippingOptionsInfoCard = styled(Card)`
	display: flex;
	flex: 1 0 auto;
	gap: 2rem;

	> button {
		flex: 0 0 auto;
		margin: auto;

		@media ${Breakpoints.mobile} {
			flex: unset;
			margin: auto;
			width: 4rem;
			height: 4rem;

			.button-text {
				display: none;
			}
		}
	}

	@media ${Breakpoints.mobile} {
		gap: unset;
		padding: 1rem;
	}
`;

export const ShippingInfo = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	flex: 1;
	gap: 1rem;

	.swiperInfo {
		@media ${Breakpoints.desktop} {
			max-width: 95rem;
		}

		@media ${Breakpoints.tablet} {
			max-width: 80rem;
		}
		@media ${Breakpoints.mobileLandscape} {
			max-width: 60rem;
		}
		@media ${Breakpoints.mobile} {
			max-width: 45rem;
		}

		width: 100%;
		height: 100%;

		.swiper-wrapper {
			transform: translateX(-1rem);
			box-sizing: border-box;
		}

		.swiper-button-prev {
			left: 0;
			right: auto;
			body[dir='rtl'] & {
				right: 0;
				left: auto;
			}
		}
		.swiper-button-next {
			right: 0.8rem;
			left: auto;
			body[dir='rtl'] & {
				right: auto;
				left: 0;
			}
		}
	}

	@media ${Breakpoints.desktop} {
		width: 85%;
	}
`;

export const InfoContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;

	@media ${Breakpoints.desktop} {
		padding: 0 2rem;
	}
`;

export const Divider = styled.div`
	border-right: 1px solid var(--border-color);
	margin: 0 var(--margin-2);
	height: 3rem;
`;

export const TooltipContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 1rem;
`;
